import React from 'react'
import Contract from '../../../../components/customer/contracts/contract/Contract'
import RoutesHelper from '../../../../helpers/RoutesHelper'

const AEACustomerContract = () => {
    return <Contract route={RoutesHelper.views.AEA.customer.contracts.Contract} />
}

export default AEACustomerContract
